import { render, staticRenderFns } from "./DetailImport.vue?vue&type=template&id=3f3cef08&"
import script from "./DetailImport.vue?vue&type=script&lang=js&"
export * from "./DetailImport.vue?vue&type=script&lang=js&"
import style0 from "./DetailImport.vue?vue&type=style&index=0&id=3f3cef08&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports